import { VonAccessRights } from "../../../../Constants/VON/EmployeeForm/vonAccessRights";
import { VonEmployeeTypes, VonEmployeeTypesText } from "../../../../Constants/VON/EmployeeForm/vonEmployeeTypes";
import { Dropdown } from "../../../FormComponents/Dropdown";
import { useTranslation } from "react-i18next";
import {useState} from "react";

const VonEditEmployeeTypeForm = ({ form, onChange, isBankruptcyTrustee, hasOtherBankruptcyTrustees }) => {
    const { t } = useTranslation();
    const { data } = form;
    const [initialData] = useState(() => structuredClone(data));

    const onFieldChange = (value) => {
        if (value !== VonEmployeeTypes.BankruptcyTrustee.toString()) {
            onChange(form.id, null, "newMainContactId");
            onChange(form.id, VonAccessRights.User, "onlineRoleId");
            onChange(form.id, false, "isPrimaryContact");
        }
        
        if (value === VonEmployeeTypes.BankruptcyTrustee.toString()) {
            onChange(form.id, VonAccessRights.Administrator, "onlineRoleId");
            
            if (!hasOtherBankruptcyTrustees) {
                onChange(form.id, true, "isPrimaryContact");
            }
            
        } 
        
        onChange(form.id, value, 'employeeTypeId');
    }

    const isConversion = initialData?.employeeTypeId === VonEmployeeTypes.Conversion;
    const disabled = isConversion || initialData?.isPrimaryContact || data.consultantId || isBankruptcyTrustee;
    const isAuditor = initialData?.employeeTypeId === VonEmployeeTypes.Auditor;

    const employeeTypes = [
        { id: VonEmployeeTypes.User, name: t(VonEmployeeTypesText[VonEmployeeTypes.User]) },
        { id: VonEmployeeTypes.BankruptcyTrustee, name: t(VonEmployeeTypesText[VonEmployeeTypes.BankruptcyTrustee]) },
        ...isConversion ? [{ id: VonEmployeeTypes.Conversion, name: t(VonEmployeeTypesText[VonEmployeeTypes.Conversion]) }] : [],
        ...isAuditor ? [{ id: VonEmployeeTypes.Auditor, name: t(VonEmployeeTypesText[VonEmployeeTypes.Auditor]) }] : []
    ]

    return <div>
        <fieldset className="d-grid col gap-16 mb-0" disabled={disabled}>
            <legend>{t('vonaccountformcontainer.changetypeofuser')}</legend>
            <Dropdown label={t('vonaccountformcontainer.typeofuser')} options={employeeTypes} initialValue={data.employeeTypeId} value={data.employeeTypeId} onChange={(value) => onFieldChange(value)} />
        </fieldset>
    </div>
}

export default VonEditEmployeeTypeForm;